import React from 'react';
import PropTypes from 'prop-types';

import Action from '../Action';

const defaultProps = {
  block: false,
  children: null,
};

const propTypes = {
  block: PropTypes.bool,
  children: PropTypes.node,
};

const PrimaryAction = ({
  block,
  children,
  ...rest
}) => (
  <Action
    block={block}
    className="bg-red-500 text-white hover:bg-red-600 hover:text-red-100 focus:shadow-outline-red"
    isLight
    {...rest}
  >
    {children}
  </Action>
);

PrimaryAction.defaultProps = defaultProps;
PrimaryAction.propTypes = propTypes;

export default PrimaryAction;
